import { Pipe, PipeTransform } from '@angular/core';
import { TIPOS_VISITAS } from 'src/app/servicios/visitantes.service';

@Pipe({
  name: 'tipoVisitaNombre'
})
export class TipoVisitaNombrePipe implements PipeTransform {
  private map = new Map<string, string>([
    ['1', 'PENDIENTE'],
    ['2', 'ENROLADO'],
    ['3', 'EN PLANTA'],
    ['4', 'RECHAZADO'],
    ['5', 'SALIDA'],
    ['0', 'HISTORIAL'],
    ['', 'TODOS'],
  ]);

  transform(value: number | string): string {
    const key = String(value);
    return this.map.get(key) || key;
  }
}
